import { useEffect } from "react";
import { SiteNav, SiteFooter, PageHero } from "@/components/SiteChrome";
import { ManufacturingQuality } from "@/components/DeepSections";

export default function ManufacturingPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-white">
      <SiteNav />
      <PageHero eyebrow="Manufacturing & Quality Assurance"
        title="Where Precision Is Engineered & Verified"
        sub="A modern facility covering turning, milling, hobbing, gear shaping and cylindrical grinding — with dedicated CMM inspection and dynamic balancing to global standards." />
      <ManufacturingQuality />
      <SiteFooter />
    </div>
  );
}
